import { gql } from "@/services/httpAdapter";

export const onRetractAllWashouts = gql`
	subscription onRetractAllWashouts($locationId: String, $commissionCycleId: String, $payPeriodId: String) {
		onRetractAllWashouts(locationId: $locationId, commissionCycleId: $commissionCycleId, payPeriodId: $payPeriodId) {
			locationId
			commissionCycleId
			payPeriodId
			statusSetBy
			statusSetOn
			positionStatus {
				position
				status
			}
		}
	}
`;
